import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@lt/components';
import CurrencyFormat from 'src/components/CurrencyFormat';
import {
  pluralizeNights,
  pluralizeTouristsAcc,
} from '../../../../utils/pluralizeUtils';
import { DEFAULT_NIGHTS_COUNT, DEFAULT_TOURISTS_COUNT } from '../../constants';

const PriceFixedButton = ({
  price,
  hotelLink,
  nightsCount,
  touristsCount,
  isHotelOnly,
}) => {
  const buttonSubtext = `На ${nightsCount} ${pluralizeNights(nightsCount)},
    на ${touristsCount} ${pluralizeTouristsAcc(touristsCount)} ${
    isHotelOnly ? '' : 'с перелётом'
  }`;
  const hasPrice = Boolean(price);

  return (
    <StyledFixedContainer>
      <Link href={hotelLink}>
        <StyledButton primary>
          {hasPrice ? (
            <>
              {isHotelOnly ? 'Выбрать номер от ' : 'Выбрать тур от '}
              <CurrencyFormat value={price} />
              <StyledButtonText>{buttonSubtext}</StyledButtonText>
            </>
          ) : (
            `Выбрать ${isHotelOnly ? `номер` : `тур`} `
          )}
        </StyledButton>
      </Link>
    </StyledFixedContainer>
  );
};

const Link = styled.a`
  text-decoration: none;
  width: 100%;
`;

const StyledFixedContainer = styled.div`
  position: sticky;
  z-index: 100;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px;
`;

const StyledButton = styled(Button)`
  position: relative;
  width: 100%;
  height: auto;
  padding: 4px 16px;

  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;

const StyledButtonText = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;

PriceFixedButton.defaultProps = {
  price: null,
  nightsCount: DEFAULT_NIGHTS_COUNT,
  touristsCount: DEFAULT_TOURISTS_COUNT,
};

PriceFixedButton.propTypes = {
  price: PropTypes.number,
  hotelLink: PropTypes.string.isRequired,
  nightsCount: PropTypes.number,
  touristsCount: PropTypes.number,
};

export default PriceFixedButton;
